import { Skeleton, Switch } from "@mui/material";
import { DDD, E2Data } from "../../lib/ddd/ddd";
import classes from "./DashboardComponents.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { OrgIdContext, ClientTypes } from "../../store/orgId_context";
import ButtonLink from "../UI/ButtonLink";
import { LineChart } from '@mui/x-charts/LineChart';
import { useTranslation } from 'react-i18next';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { normalizeLocaleCode } from "../../lib/normalizeLocaleCode";

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";
const e2Data = new E2Data("EU_Analyze_InvoicesAnalitic");

var _date = new Date();
_date.setFullYear( _date.getFullYear() - 1 );
const blackDataSet = [];
for(let i=0;i<12;i++){
    var month = _date.getMonth()+1;

    let monthKey = month;
    if(month<10)
        monthKey= "0"+month;
    blackDataSet.push( {CreatePeriod: _date.getFullYear()+""+monthKey, iei : 0, rei: 0, ieiTest: 0, reiTest: 0});

    _date.setMonth(_date.getMonth()+1);
}

function formatDate(yyyymm, language = 'en') {
    const year = yyyymm.slice(0, 4);
    const month = yyyymm.slice(4, 6);
    const date = new Date(`${year}-${month}-01`);

    const formatter = new Intl.DateTimeFormat(language, {
        month: 'short',
        year: 'numeric'
    });

    // Return the formatted date
    return formatter.format(date);
}

function formatDateLocalized(dateString, language="en") {
    // Extract year and month
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);

    // Create a date object (day set to 1 to avoid month overflow issues)
    const date = new Date(`${year}-${month}-01`);

    // Format the month using Intl.DateTimeFormat
    const monthName = new Intl.DateTimeFormat(normalizeLocaleCode(language), { month: "short" }).format(date);

    // Return formatted string with line break
    return `${monthName} \n ${year}`;
}

const InvoicesGraph = () => {
    const {mainOrgId, aboutOrgId, clientType} = useContext(OrgIdContext);
    const [filter, setFilter] = useState();
    const [table, setTable] = useState()
    const [data, setData] = useState();
    const [hasData, setHasData] = useState(false);
    const [xAxis, setXAxis] = useState([]);
    const [xAxisKeys, setXAxisKeys] = useState([]);
    const [series, setSeries] =  useState([]);
    const [mode, setMode] = useState("PROD");
    const [dataset, setDataset] = useState(blackDataSet);
    const [maxNum, setMaxNum] = useState(0);
    const { t, i18n  } = useTranslation();
    const currentLanguage = i18n.language; // Get current language


    const {isPending : isLoading, data : queryData} = useQuery({
        queryKey: ['Data.GetEntityData', table , e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
        staleTime: "Infinity",
        enabled : filter!==undefined
    });

    useEffect(() => {
        if(!aboutOrgId)return;

        var _date = new Date();
        _date.setFullYear( _date.getFullYear() - 1 );
        var month = _date.getMonth()+1;
        if(month < 10)
            month="0"+month;
        var filterDate = _date.getFullYear()+""+month;
        var filter=  `CreatePeriod>="${filterDate}" AND `;
        filter += (clientType===ClientTypes.EndClient || clientType===ClientTypes.Company) ? `OrgId="${aboutOrgId}"` : `TransformerId="${mainOrgId}"`;
        //console.log(filter);
        //var filter=  `OrgId="${'2776b05d-9ad1-11ec-90fb-faa8f752a7b9'}" AND CreatePeriod>="${filterDate}"`;
        e2Data.filter = filter;
        e2Data.take=1000;
        e2Data.entity = (clientType===ClientTypes.EndClient || clientType===ClientTypes.Company) ? "EU_Analyze_InvoicesAnalitic" : "EU_TransformerCustomers_InvoicesSum";
        setTable((clientType===ClientTypes.EndClient || clientType===ClientTypes.Company) ? "EU_Analyze_InvoicesAnalitic" : "EU_TransformerCustomers_InvoicesSum")
        setFilter(filter);
    }, [aboutOrgId]);

    useEffect(() => {
        if(isLoading) return;
        if(!queryData?.result?.data || queryData?.result?.data?.length === 0) return setHasData(false);

        setHasData(true);
        let maxNum=0;
        queryData.result.data.forEach(x => {
            const row = dataset.find(y => y.CreatePeriod === x.CreatePeriod);
            if(!row) return;
            if(clientType===ClientTypes.ISV){
                row.rei = x.InvNumThisMonthREI;
                row.reiTest = 0;
                row.iei = x.InvNumThisMonthIEI;
                row.ieiTest = x.InvNumThisMonthTEST;
                maxNum = Math.max(maxNum, x.InvNumThisMonthREI, x.InvNumThisMonthIEI, x.InvNumThisMonthTEST);
            }else{
                if(x.Destination === "REI" && x.Mode === "PROD")
                    row.rei = x.NoOfInv;
                if(x.Destination === "REI" && x.Mode === "TEST")
                    row.reiTest = x.NoOfInv;
                if(x.Destination === "IEI" && x.Mode === "PROD")
                    row.iei = x.NoOfInv;
                if(x.Destination === "IEI" && x.Mode === "TEST")
                    row.ieiTest = x.NoOfInv;
                maxNum = Math.max(maxNum, x.NoOfInv);
            }
            
        });
        //console.log(dataset);
        setMaxNum(maxNum);
        setDataset([...dataset]);
    },[queryData,isLoading]);

    /*useEffect(() => {
        if(isLoading || !queryData)return;

        setData(queryData.result?.data);
        console.log(queryData);
        var _date = new Date();
        _date.setFullYear( _date.getFullYear() - 1 );
        let xAxis=[];
        let xAxisKeys = [];
        for(let i=0;i<12;i++){
            var month = _date.getMonth()+1;
            xAxis.push(month);

            let monthKey = month;
            if(month<10)
                monthKey= "0"+month;
            xAxisKeys.push( _date.getFullYear()+""+monthKey);

            _date.setMonth(_date.getMonth()+1);
        }
        console.log(xAxis);
        setXAxis(xAxis);
        setXAxisKeys(xAxisKeys);
        
        loadSeries(xAxisKeys, queryData.result?.data);
    }, [queryData,isLoading, mode]);*/

    const loadSeries = (keys, data) => {
        if(!keys || !data) return;
        let destinations = [
            {title: "Received", destination : "REI"}, 
            {title: "Issued", destination: "IEI"}];
        let dataFound = false;
        let _series = [];

        for(let destination of destinations){
            var ser = {};
            ser.label = destination.title;
            ser.yAxisKey = "yAxisId";
            ser.dataKey = "NumOfInvoices";
            ser.data = [];

            for(let key of keys){
                let val2 = {NumOfInvoices: 0, CreatePeriod: key};
                let val = 0;
                for(var i=0;i<data.length;i++){
                    if(data[i].CreatePeriod === key && data[i].Destination === destination.destination && data[i].Mode === mode){
                        dataFound = true;
                        val = data[i].NoOfInv;
                        val2.NumOfInvoices = val;
                    }
                }
                //ser.data.push(val);
                ser.data.push(val2);
                
            }
console.log(ser.data);
            _series.push(ser);
        }
        if(!dataFound)
            fillSeriesWithFakeData(_series);

        setHasData(dataFound);
        setSeries(_series);
    }

    const fillSeriesWithFakeData = (data) =>{
        for(const serie of data){
            let fakeData= [];
            serie.data.forEach(x => fakeData.push(Math.floor(Math.random() * 100 + 50)))
            serie.data = fakeData;
        }
    }

    const onChangeMode = () =>{
        setMode(mode === "PROD" ? "TEST" : "PROD");
    }


    return (<>
    <div className={classes["graph-container"]}>
    
        <Row className={hasData ? "" : classes["graph-nodata-blur"]} style={{height:"100%", maxHeight:"250px", minHeight:"200px"}}>
            {isLoading && <Skeleton style={{height:"100%", maxHeight:"250px", minHeight:"200px"}}/>}
            {queryData && dataset && <LineChart
            dataset={dataset}
            //axisHighlight={{ x: "none", y: "none" }}
            margin={{ left: 70}}
            grid={{ vertical: true, horizontal: true }}
            yAxis={
                [{
                    //id : "yAxisId",
                    min:0,
                    label: t('Number of invoices'),
                    //labelStyle:{transform: 'translateX(30px)'},
                }]
            }
            xAxis={[{ 
                //data: xAxis,
                scaleType: 'point',
                dataKey: 'CreatePeriod',
                valueFormatter: (value, context) => {
                    return formatDateLocalized(value, currentLanguage);
                }
            }]}
            sx={{
                [`.${axisClasses.left} .${axisClasses.label}`]: maxNum > 100 ? {
                  transform: 'translateX(-20px)',
                } : {transform: 'translateX(-10px)'},
                '& .MuiChartsAxis-label': {
                fill: '#005683',
                },
                '& .MuiChartsAxis-tickLabel': {
                    fill: '#005683',
                },
                '& .MuiChartsGrid-line': {
                    stroke: '#005683',
                },
              }}
            //series={series}
            series={[{ dataKey: mode === "PROD" ? 'iei' : 'ieiTest', label: t('Issued'), area:false, color:"#005683" }, { dataKey:  mode === "PROD" ? 'rei' : 'reiTest', label: t('Received'), area:false, color:"#df511d" }]}
            //leftAxis={"yAxisId"}
            />}
        </Row>
        {hasData && <div style={{position:"absolute", top:"5px", right:"5px"}}>
            <OverlayTrigger placement="top" overlay={<Tooltip>{t("Show test invoices")}</Tooltip>}>
            <   Switch checked={mode==="TEST"} onChange={onChangeMode} size="small"/>
            </OverlayTrigger>
        </div>}
        {!hasData && <div className={classes["graph-nodata-text"]}>{t("No data")}</div>}
    </div>
    </>);
}

export default InvoicesGraph;